import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 8v5h2v-3h3V8H7ZM15 16h-5v-2h3v-3h2v5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 0 2 2v2H4Zm14.535-2A3.982 3.982 0 0 1 18 17V5H4v14h14.535Z"
    />
  </svg>
);
export default IconLentaStrokedSizeM;
